(function(){
  'use strict';
  var TARGET = 5;

  function esc(s){ return (s||'').replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function moneyFromCents(cents){ return '$' + ((cents || 0)/100).toFixed(2) + ' USD'; }
  function moneyFromDecimal(v){ return '$' + parseFloat(v || 0).toFixed(2) + ' USD'; }
  function withWidth(u){
    if(!u) return '';
    var sep = u.indexOf('?') === -1 ? '?' : '&';
    return u + sep + 'width=360';
  }
  var cartIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6h15l-1.6 9.2a1 1 0 0 1-1 .8H8.4a1 1 0 0 1-1-.8L5 3H2"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M12 9.5v4M10 11.5h4"/></svg>';
  var checkIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12l5 5L20 6"/></svg>';
  var viewIcon = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>';

  // Tier 0: Shopify's own recommendation engine -- best relevance signal,
  // tried first. Price comes back in cents. Some products in the catalog
  // have no featured_image, so fall back to the first entry in images[]
  // rather than leaving the card blank.
  function fromNative(productId, seen, limit){
    if(limit <= 0) return Promise.resolve([]);
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.products) || [];
        var out = [];
        for(var i = 0; i < products.length && out.length < limit; i++){
          var p = products[i];
          if(seen[String(p.id)]) continue;
          seen[String(p.id)] = true;
          var variant = (p.variants && p.variants[0]) || null;
          var rawImg = p.featured_image || (p.images && p.images[0]) || '';
          out.push({
            title: p.title,
            url: p.url,
            image: withWidth(rawImg ? ('https:' + rawImg) : ''),
            priceDisplay: moneyFromCents(p.price),
            available: !!(variant && p.available),
            variantId: variant ? variant.id : null
          });
        }
        return out;
      })
      .catch(function(){ return []; });
  }

  // Tier 1 (same type) / Tier 2 (same vendor): predictive search.
  function fromSuggest(field, value, seen, limit){
    if(!value || limit <= 0) return Promise.resolve([]);
    var q = field + ':"' + value + '"';
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=20')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var out = [];
        for(var i = 0; i < products.length && out.length < limit; i++){
          var p = products[i];
          if(seen[String(p.id)]) continue;
          seen[String(p.id)] = true;
          var rawImg = (p.featured_image && p.featured_image.url) || p.image || '';
          out.push({
            title: p.title,
            url: (p.url || '').split('?')[0],
            image: withWidth(rawImg),
            priceDisplay: moneyFromDecimal(p.price),
            available: p.available !== false,
            variantId: null
          });
        }
        return out;
      })
      .catch(function(){ return []; });
  }

  // Tier 3: the product's own real collection (its actual store category).
  function fromCollection(handle, seen, limit){
    if(!handle || limit <= 0) return Promise.resolve([]);
    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=20')
      .then(function(r){ return r.json(); })
      .then(function(data){
        var products = (data && data.products) || [];
        var out = [];
        for(var i = 0; i < products.length && out.length < limit; i++){
          var p = products[i];
          if(seen[String(p.id)]) continue;
          seen[String(p.id)] = true;
          var v = (p.variants && p.variants[0]) || {};
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          out.push({
            title: p.title,
            url: '/products/' + p.handle,
            image: withWidth(img),
            priceDisplay: moneyFromDecimal(v.price),
            available: v.available !== false,
            variantId: v.id || null
          });
        }
        return out;
      })
      .catch(function(){ return []; });
  }

  document.querySelectorAll('[data-recommendations]').forEach(function(section){
    var productId = section.getAttribute('data-product-id');
    var vendor = section.getAttribute('data-vendor');
    var type = section.getAttribute('data-type');
    var categoryHandle = section.getAttribute('data-category-handle');
    var track = section.querySelector('[data-slider-track]');
    if(!productId || !track) return;

    var seen = {};
    seen[String(productId)] = true;

    function render(products){
      track.innerHTML = products.map(function(p){
        var addBtn = (p.variantId && p.available)
          ? '<button type="button" class="card__addcart" data-quick-add data-variant-id="' + p.variantId + '" aria-label="Add ' + esc(p.title) + ' to cart">' + cartIcon + '</button>'
          : '';
        return '<div class="slider__slide">' +
          '<div class="card">' +
            '<div class="card__media">' +
              '<a href="' + p.url + '" tabindex="-1" aria-hidden="true"><img src="' + p.image + '" width="360" height="360" alt="' + esc(p.title) + '" loading="lazy"></a>' +
              '<a href="' + p.url + '" class="card__view" aria-label="View ' + esc(p.title) + '">' + viewIcon + '</a>' +
              addBtn +
            '</div>' +
            '<a href="' + p.url + '" class="card__title">' + esc(p.title) + '</a>' +
            '<p class="card__price">' + p.priceDisplay + '</p>' +
          '</div>' +
        '</div>';
      }).join('');
      section.hidden = false;

      track.querySelectorAll('[data-quick-add]').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          if(btn.disabled) return;
          btn.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
          }).then(function(r){
            if(!r.ok) throw new Error('add failed');
            return r.json();
          }).then(function(){
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            btn.innerHTML = checkIcon;
            btn.classList.add('card__addcart--done');
            setTimeout(function(){
              btn.innerHTML = cartIcon;
              btn.classList.remove('card__addcart--done');
              btn.disabled = false;
            }, 1400);
          }).catch(function(){
            btn.disabled = false;
          });
        });
      });

      if(window.initTrackSlider){
        window.initTrackSlider(section);
      }
    }

    // Relevance-first, additive fill: Shopify's own recommendation engine
    // first, then top up from same type, then same brand, then same
    // collection (category), stopping once TARGET unique products are
    // found or every tier is exhausted. Leaves the section hidden only if
    // no tier finds a single real match.
    fromNative(productId, seen, TARGET)
      .then(function(items){
        if(items.length >= TARGET) return items;
        return fromSuggest('product_type', type, seen, TARGET - items.length).then(function(more){ return items.concat(more); });
      })
      .then(function(items){
        if(items.length >= TARGET) return items;
        return fromSuggest('vendor', vendor, seen, TARGET - items.length).then(function(more){ return items.concat(more); });
      })
      .then(function(items){
        if(items.length >= TARGET) return items;
        return fromCollection(categoryHandle, seen, TARGET - items.length).then(function(more){ return items.concat(more); });
      })
      .then(function(items){
        if(!items.length) return;
        render(items);
      })
      .catch(function(){ /* leave hidden */ });
  });
})();
